import React from 'react';
import { Datagrid, ListContextProvider } from 'react-admin';

import { CssRowFieldCellWrapper } from '../fields/CssFieldCellWrapper';
import { ScrollingWrapper } from '../ScrollingWrapper';

export const HighlightList = ({value, children, cssFnRow, Actions, sharedFieldsProps = {} }) => (
	value ? (
		<ListContextProvider value={value}>
			{Actions && React.cloneElement(Actions)}
			<div style={{ 
				maxHeight: "75vh", 
				overflowY: "auto",
				display: "flex",
				flexDirection: "column"
			}}>
				<ScrollingWrapper style={{ 
					overflowX: "auto", 
					minHeight: 0 
				}}>
					<Datagrid size="small" rowClick={null} hover={false} optimized={false}>
						<CssRowFieldCellWrapper cssFn={cssFnRow} />
						{React.Children.map(
							children,
							(child) => child ? React.cloneElement(child, {...child.props, sharedFieldsProps}) : null
						)}
					</Datagrid>
				</ScrollingWrapper>
			</div>
		</ListContextProvider>
		) 
	: <></>
);
